"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { ubeTracking } from "@/lib/ube-tracking";

function getScreenName(pathname: string): string {
  // Remove /stories-of-us prefix
  const path = pathname.replace('/stories-of-us', '') || '/';
  
  if (path === '/') return 'lohp-ui : stories-of-us';
  if (path === '/map') return 'lohp-ui : stories-of-us : subpages : map';
  if (path === '/styleguide') return 'lohp-ui : stories-of-us : subpages : styleguide';
  if (path === '/record-gallery') return 'lohp-ui : stories-of-us : subpages : record-gallery';
  if (path === '/250-stories') return 'lohp-ui : stories-of-us : subpages : 250-stories';
  if (path === '/250-stories/upload') return 'lohp-ui : stories-of-us : subpages : 250-stories : upload';
  
  // Dynamic routes
  if (path.startsWith('/250-stories/')) {
    const story = path.split('/')[2];
    return `lohp-ui : stories-of-us : subpages : 250-Stories : ${story}`;
  }
  
  if (path.startsWith('/record-gallery/')) {
    const parts = path.split('/').filter(Boolean);
    if (parts.length === 2) {
      return `lohp-ui : stories-of-us : subpages : record-gallery : ${parts[1]}`;
    }
    if (parts.length === 3) {
      return `lohp-ui : stories-of-us : subpages : record-gallery : ${parts[1]} : ${parts[2]}`;
    }
  }
  
  return `lohp-ui : stories-of-us : ${path}`;
}

export default function UBEPageTracker() {
  const pathname = usePathname();

  useEffect(() => {
    const screenName = getScreenName(pathname);
    ubeTracking.trackScreenView(screenName);
  }, [pathname]);

  return null;
}
